export default "__VITE_ASSET__Dc6qU9n$__"